import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
//import ImageUpload from "../../components/imageUpload.js";

const ServiceTypeEdit = ()=>{
     const [type, setType ] = useState('');
     const [serviceCode, setServiceCode ] = useState('');
     const [createdAt, setCreatedAt ] = useState('');
     const [updatedAt, setUpdatedAt ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const ref = useRef<HTMLInputElement>(null);

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`serviceType/${id}`);
                 setType(data.type);
                 setServiceCode(data.service_code);
                 setCreatedAt(data.created_at);
                 setUpdatedAt(data.updated_at);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`serviceType/${id}`, {
            type,
            serviceCode,
            createdAt,
            updatedAt,
        });
        console.log(data);
        setRedirect(true);
    };
//     const updateImage = (url) =>{
//         if(ref.current){
//             ref.current.value = url;
//         }
// // setLogoImage(url);
//     }
    if(redirect){
         return <Navigate to={'/serviceType'} />
    }
    return (
        <Wrapper pageTitle={'Edit ServiceType'}>
            <InnerNav createLink={'/serviceTypeCreate'} listLink={'/serviceType'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Type </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Type" value={type}
                        onChange = {e => setType(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ServiceCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ServiceCode" value={serviceCode}
                        onChange = {e => setServiceCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">CreatedAt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="CreatedAt" value={createdAt}
                        onChange = {e => setCreatedAt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">UpdatedAt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="UpdatedAt" value={updatedAt}
                        onChange = {e => setUpdatedAt(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default ServiceTypeEdit;